import { RESET_VERIFICATION_UPLOAD_DOCUMENTS } from 'constants';
import {
  PII_PROFILE_PERSONAL_DETAILS_FISTNAME_NAME,
  PII_PROFILE_PERSONAL_DETAILS_LASTNAME_NAME,
  PII_PROFILE_PERSONAL_DETAILS_OCCUPATION_NAME,
  PII_PROFILE_RESIDENTIAL_ADDRESS_FINDER_NAME,
  PII_PROFILE_RESIDENTIAL_ADDRESS_SWITCH_NAME,
  RESET_PII_PROFILE_PERSONAL_DETAILS,
  RESET_PII_PROFILE_RESIDENTIAL_ADDRESS,
} from 'features/pii/const';
import useProfile from 'features/profile2.0/hooks/useProfile';
import useForm from 'hooks/form/useForm';
import { isEmpty } from 'lodash';
import React, { useEffect } from 'react';
import useProfileKYCStore from '../hooks/useProfileKYCStore';
import withGetProfileOccupation from './withGetProfileOccupation';

const initialFormField = {
  ...RESET_PII_PROFILE_PERSONAL_DETAILS,
  ...RESET_VERIFICATION_UPLOAD_DOCUMENTS,
  ...RESET_PII_PROFILE_RESIDENTIAL_ADDRESS,
};

const withFormProfileKYCModalInitial = (Component) => {
  const FormProfileKYCModalInitialComponent = withGetProfileOccupation(
    (props) => {
      const { currentUser } = useProfile();
      let { firstName, lastName, address } = currentUser || {};
      // address = {
      //   fullAddress: 'U 2 172 MARION ST 2200 BANKSTOWN NSW',
      //   street: 'U 2 172 MARION ST',
      //   suburb: 'BANKSTOWN',
      //   state: 'NSW',
      //   postcode: '2200',
      //   manual: false,
      // };
      const { fullAddress, manual } = address || {};

      const { profileOccupation, setFormProfileKYCInformation } =
        useProfileKYCStore();

      const {
        information,
        setInformation,
        validation,
        setValidation,
        checkAllowSubmit,
      } = useForm(initialFormField);

      useEffect(() => {
        if (isEmpty(currentUser)) return;
        if (isEmpty(profileOccupation)) return;
        const informationInitial = {
          ...initialFormField,
          // Personal details
          [PII_PROFILE_PERSONAL_DETAILS_FISTNAME_NAME]: firstName,
          [PII_PROFILE_PERSONAL_DETAILS_LASTNAME_NAME]: lastName,
          [PII_PROFILE_PERSONAL_DETAILS_OCCUPATION_NAME]:
            profileOccupation?.job,
          // Residential address
          [PII_PROFILE_RESIDENTIAL_ADDRESS_SWITCH_NAME]: manual,
          [PII_PROFILE_RESIDENTIAL_ADDRESS_FINDER_NAME]: fullAddress,
        };
        console.log(
          `⭐ withFormProfileKYCModalInitial 👉 useEffect ➡️ informationInitial ↩`,
          informationInitial
        );
        setInformation(informationInitial);
        setFormProfileKYCInformation(informationInitial);
      }, [currentUser, profileOccupation]);

      const newProps = {
        ...props,
        information,
        setInformation,
        validation,
        setValidation,
        checkAllowSubmit,
      };
      return <Component {...newProps} />;
    }
  );
  return FormProfileKYCModalInitialComponent;
};

export default withFormProfileKYCModalInitial;
